import { Component, Input } from '@angular/core';
import { ApiService } from '@lsq-frontend/angular-shared/api-service';
import { ResponsiveService } from '../../../services/responsive/responsive.service';

export interface LsqBarDataPoint {
    label: string;
    data: string;
    exportInformation?: {
        request: any;
        service: ApiService<any, any>;
        reportName: string;
    };
}
@Component({
    selector: 'lsq-data-point-bar',
    templateUrl: './lsq-data-point-bar.component.html',
    styleUrls: ['./lsq-data-point-bar.component.scss']
})
export class LsqDataPointBarComponent {
    @Input() public dataPoints!: LsqBarDataPoint[];
    @Input() public loading = false;
    @Input() public isLeftAligned = false;

    constructor(public responsiveService: ResponsiveService) {}

    // This is mainly to support very large currencies, but can also help when KPIs are very large
    public isLargeDataPoints(dataPoints?: LsqBarDataPoint[]): boolean {
        return !!dataPoints?.some((dataPoint) => dataPoint.data.length >= 18);
    }
}
